









/* eslint-disable @typescript-eslint/camelcase */
import API from '@core/services/API'
import { inject } from 'inversify-props'
import { Component, Vue } from 'vue-property-decorator'
import { UIService } from '@core/services/UIService'
import { SharedVariable } from '@core/model/SharedVariable'

@Component
export default class InfoSheetSection extends Vue {
  @inject()
  private $api: API

  uiService: UIService

  @inject()
  private sharedVariable: SharedVariable

  private excelFile: any = null

  get isDisabled () {
    return this.$store.getters.currentUser.systemrole !== 'ops-staff'
  }

  async excelFileChange (e) {
    if (e.target.files && e.target.files.length >= 1) {
      this.excelFile = this.convertObjToList(e.target.files)
    }
  }

  convertObjToList (obj) {
    const result = Object.keys(obj).map((key) => {
      return obj[key]
    })
    return result
  }

  async saveExcelInfoSheet () {
    if (!this.excelFile) {
      await this.uiService.alert.show({
        type: 'warning',
        message: 'Please upload the excel file!'
      })
      return
    }
    await this.$api.clientPolicy.saveExcelInfo({
      policy_profile_oid: '',
      info_sheet_excel_file: this.excelFile[0]
    })
  }

  mounted () {
    // take injected UIService and set it to local
    this.uiService = this.sharedVariable.uiService
  }
}
